import { BLACK, BLACK_400, BLACK_500, BLACK_700, BLUE_500, BLUE_GREY_200, BLUE_GREY_400, RED_500, GREEN_600, YELLOW_600, WHITE } from '../colors';
var notifierConfig = {
  theme: 'light',
  size: 'md',
  hasDot: false,
  state: 'default',
  number: 9,
  config: {
    size: {
      sm: {
        notifierNumberSize: 16,
        notifierDotSize: 8,
        notifierIconSize: 10
      },
      md: {
        notifierNumberSize: 16,
        notifierDotSize: 12,
        notifierIconSize: 10
      },
      lg: {
        notifierNumberSize: 16,
        notifierDotSize: 16,
        notifierIconSize: 10
      }
    },
    controlState: {
      default: {
        dotBorderColor: WHITE,
        backgroundColor: BLUE_500,
        color: WHITE
      },
      success: {
        dotBorderColor: WHITE,
        backgroundColor: GREEN_600,
        color: WHITE
      },
      warning: {
        dotBorderColor: WHITE,
        backgroundColor: YELLOW_600,
        color: BLACK
      },
      danger: {
        dotBorderColor: WHITE,
        backgroundColor: RED_500,
        color: WHITE
      },
      disabled: {
        dotBorderColor: BLACK_400,
        backgroundColor: BLACK_500,
        color: BLACK_700
      }
    }
  }
};
var notifierWhiteConfig = Object.assign(Object.assign({}, notifierConfig), {
  config: Object.assign(Object.assign({}, notifierConfig.config), {
    controlState: Object.assign(Object.assign({}, notifierConfig.config.controlState), {
      disabled: {
        dotBorderColor: BLUE_GREY_400,
        backgroundColor: BLUE_GREY_200,
        color: BLUE_GREY_400
      }
    })
  })
});
export default {
  light: notifierConfig,
  dark: notifierConfig,
  white: notifierWhiteConfig
};